import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useLocation } from "react-router-dom";

const MainLayout = () => {
  const pageNameRoute = useLocation();


  return (
    <>
      <Navbar />
      <main style={{ height: "100%", width: "100%", overflow: "auto" }}>
        <Outlet />

        {pageNameRoute?.pathname === "/" && (
          <div className="social-btns d-center">
            <a
              href="https://wa.me/+919108703683"
              className="btn whatsapp d-center"
            >
              <i className="fab fa-whatsapp" aria-hidden="true"></i>
            </a>

            <a href="tel:+919108703683" className="btn phone d-center">
              <i className="fa fa-phone"></i>
            </a>
          </div>
        )}
      </main>
    </>
  );
};

export default MainLayout;
